import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import ServicesExpanded from './components/ServicesExpanded';
import HowItWorks from './components/HowItWorks';
import WhoWeWorkWith from './components/WhoWeWorkWith';
import CaseStudy from './components/CaseStudy';
import Values from './components/Values';
import Packages from './components/Packages';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import ClientReadiness from './components/ClientReadiness';
import UnifiedContactForm from './components/UnifiedContactForm';
import BlogPreviewSection from './components/BlogPreviewSection';
import InstagramSpotlight from './components/InstagramSpotlight';
import ChatWidget from './components/ChatWidget';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LandingV2 from './pages/v2/LandingV2';
import AuditV2 from './pages/v2/AuditV2';
import ServicesV2 from './pages/v2/ServicesV2';
import ServiceDetailV2 from './pages/v2/ServiceDetailV2';
import ContactV2 from './pages/v2/ContactV2';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import LeadProfilePage from './pages/admin/LeadProfilePage';
import BlogIndexPage from './pages/BlogIndexPage';
import BlogPostPage from './pages/BlogPostPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import RefundsPage from './pages/RefundsPage';
import './styles/main.css';
import './styles/admin.css';
import './styles/content.css';
import './styles/ops.css';
import './styles/overflow-safety.css';
import './styles/landing-polish.css';
import './styles/motion.css';
import './styles/adminMobile.css';

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <TrustBadges />
      <ServicesExpanded />
      <HowItWorks />
      <WhoWeWorkWith />
      <CaseStudy />
      <Values />
      <Packages />
      <Testimonials />
      <BlogPreviewSection />
      <FAQSection />
      <ClientReadiness />
      <UnifiedContactForm />
      <InstagramSpotlight />
      <Contact />
    </main>
    <Footer />
    <ChatWidget />
  </>
);

const BlogListLayout = () => (
  <>
    <Header />
    <main>
      <BlogIndexPage />
    </main>
    <Footer />
    <ChatWidget />
  </>
);

const BlogPostLayout = () => (
  <>
    <Header />
    <main>
      <BlogPostPage />
    </main>
    <Footer />
    <ChatWidget />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <Routes>
              {/* V2 public site: bilingual EN/ES landing at root. `/v2` retained as alias for existing shared links. */}
              <Route path="/" element={<LandingV2 />} />
              <Route path="/v2" element={<LandingV2 />} />
              <Route path="/v2/audit" element={<AuditV2 />} />
              <Route path="/v2/services" element={<ServicesV2 />} />
              <Route path="/v2/services/:slug" element={<ServiceDetailV2 />} />
              <Route path="/v2/contact" element={<ContactV2 />} />
              {/* Legacy homepage component (<HomePage />) is preserved in this file above but intentionally unrouted — not publicly accessible. */}
              <Route path="/blog" element={<BlogListLayout />} />
              <Route path="/blog/:slug" element={<BlogPostLayout />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/refunds" element={<RefundsPage />} />
              <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/dashboard" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/leads/:leadId" 
                element={
                  <ProtectedRoute>
                    <LeadProfilePage />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
